// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ml-0";
export var discountCodeInput = "_ml-1";